// extracted by mini-css-extract-plugin
export default {"header":"styles_header__g3bSP","sidebar":"styles_sidebar__WfJG7","children":"styles_children__s6F8l","accountLayout":"styles_accountLayout__SMeWS"};